// extracted by mini-css-extract-plugin
export var icons = "staff-module--icons--de938";
export var imgContainer = "staff-module--img-container--9afc1";
export var leader = "staff-module--leader--57de7";
export var leaderDescription = "staff-module--leader-description--b098b";
export var leadership = "staff-module--leadership--cd0bb";